var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.feedback)?_c('em',[_vm._v(_vm._s(_vm.feedback))]):_vm._e(),_vm._v(" "),_c('showProfileTemplate',{attrs:{"userDetails":_vm.userDetails,"routeusername":this.$route.params.username}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfbdbe94","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/Dynamic/_mainDirectives/myprofile/my/showingProfileBreif.vue
// module id = 621
// module chunks = 0